<template>
  <v-container fluid>
    <a-tabs v-model="S" size="small" @change="(v) => changeTabS(v)">
      <a-tab-pane v-for="(item, index) in sections" :key="index" :tab="item.text">
      </a-tab-pane>
    </a-tabs>
    <a-tabs v-model="A" size="small" :type="section === '未分配' ? 'card' : 'editable-card'" @edit="onEditA"
      @change="(v) => changeTabA(v)">
      <a-tab-pane v-for="(item, index) in lines" :key="index" :tab="item.text">
        <a-space class="mb-2">
          <v-btn color="primary" small tile @click="getdata()">
            <v-icon small>mdi-refresh</v-icon> 刷新
          </v-btn>
          <v-btn color="primary" small tile @click="() => {
            showview = showview === 'table' ? 'timeline' : 'table';
          }">
            <v-icon small>mdi-refresh</v-icon> 切换{{ showview === 'table' ? '时间轴' : '表格' }}
          </v-btn>
          <v-btn color="primary" small tile @click="showeditline()">
            <v-icon small>mdi-cog</v-icon> 线路设置
          </v-btn>
          <a-popconfirm placement="right" title="清空节点数据" ok-text="确定" cancel-text="取消" @confirm="reset">
            <v-btn color="error" small tile>
              <v-icon small>mdi-delete</v-icon> 清空节点
            </v-btn>
          </a-popconfirm>
        </a-space>
      </a-tab-pane>
    </a-tabs>
    <a-tabs v-model="B" size="small" :type="(section === '未分配' || !lineid) ? 'card' : 'editable-card'" @edit="onEditB"
      @change="(v) => changeTabB(v)">
      <a-tab-pane v-for="(item, index) in vehicles" :key="index" :tab="item.text">
        <a-space>
          <template v-if="vehicle">
            <v-btn color="success" small tile @click="init()">
              <v-icon small>mdi-plus</v-icon> 添加节点
            </v-btn>
            <v-checkbox v-model="ignore_oneday" label="忽略24小时周期" hide-details="auto" dense>
            </v-checkbox>
          </template>
        </a-space>
      </a-tab-pane>
    </a-tabs>
    <v-card v-if="showview === 'table'" id="timeline-card">
      <v-card-text>
        <v-data-table :headers="headers" :items="list" :items-per-page="list.length" no-data-text="无数据"
          hide-default-footer disable-sort fixed-header :height="height">
          <template v-slot:item.index="{ index, item }">
            <span v-if="item._id">{{ index }}</span>
          </template>
          <template v-slot:item.A="{ item }">
            <span>
              <span v-if="item.A_days" class="font-weight-bold success--text">(+{{ item.A_days }})</span>
              {{ item.A }}
            </span>
            <p class="error--text font-weight-bold">{{ item.J }}</p>
          </template>
          <template v-slot:item.C="{ item }">
            <v-badge v-if="item.C_i" color="red" :content="item.C_i">{{ item.C }}</v-badge>
            <span v-else>{{ item.C }}</span>
          </template>
          <template v-slot:item.D="{ item }">
            <span v-if="item._id">{{ item.D }}<span v-if="item.D_hour">({{ item.D_hour }})</span></span>
            <span v-else class="text-h6 error--text">{{ item.D }}</span>
          </template>
          <template v-slot:item.E="{ item }">
            <span v-if="item._id">{{ item.E }}<span v-if="item.E_km">({{ item.E_km }})</span></span>
            <span v-else class="text-h6 error--text">{{ item.E }}</span>
          </template>
          <template v-slot:item.F="{ item }">
            <span v-if="item._id">{{ item.F }}</span>
            <span v-else class="text-h6 error--text">{{ item.F }}</span>
          </template>
          <template v-slot:item.H="{ item }">
            <a-space>
              <span>{{ item.H }}</span>
              <v-btn v-if="item.editable" color="primary" tile text small @click="showeditschedule(item)">编辑</v-btn>
            </a-space>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
    <v-card v-if="showview === 'timeline'" class="pa-2" id="timeline-card">
      <v-snake-timeline :data="list2" :columns="6" :line-width="2" :row-height="200" line-style="dashed">
        <template #line-top="{ item }">
          <span>{{ item.A1 }}</span>
        </template>
        <template #line-bottom="{ item }">
          <v-card class="elevation-2" :width="width">
            <v-card-title class="pa-0 pl-1 pr-1 ma-0">
              <span>{{ item.B }}</span>
            </v-card-title>
            <v-card-text class="white text--primary pa-1">
              <p>
                <v-badge v-if="item.C_i" color="red" :content="item.C_i">{{ item.C }}</v-badge>
                <span v-else>{{ item.C }}</span>
              </p>
              <p>{{ item.D }}</p>
              <p>{{ item.E }}</p>
              <p>{{ item.F }}</p>
            </v-card-text>
          </v-card>
        </template>
      </v-snake-timeline>
    </v-card>
    <!--添加线路-->
    <v-dialog v-model="linemodel" persistent :width="600">
      <v-form ref="lineform" v-model="linevalid" lazy-validation>
        <v-card>
          <v-card-title class="grey lighten-4 pa-2 text-subtitle-1 mb-4 d-flex justify-space-between">
            <span class="text-h6">{{ lineform._id ? '编辑线路' : '添加线路' }}
              <span class="error--text">
                {{ lineform._id ? line.text : '' }}</span>
            </span>
            <v-icon @click="cancelsaveline">mdi-close</v-icon>
          </v-card-title>
          <v-card-text>
            <v-container style="max-height:600px;overflow-y:auto;">
              <v-row>
                <v-col cols="12">
                  <v-select v-model="lineform.section" :items="sections.filter(n => n.value !== '未分配')"
                    :menu-props="{ bottom: true, offsetY: true }" no-data-text="无" dense outlined>
                    <template v-slot:label>
                      标段<span class="red--text">*</span>
                    </template>
                  </v-select>
                </v-col>
                <v-col cols="6">
                  <v-text-field v-model="lineform.departure" :rules="[vrules.required]" dense outlined
                    :disabled="lineform._id !== ''">
                    <template v-slot:label>
                      线路起点<span class="red--text">*</span>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field v-model="lineform.destination" :rules="[vrules.required]" dense outlined
                    :disabled="lineform._id !== ''">
                    <template v-slot:label>
                      线路终点<span class="red--text">*</span>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="6" v-if="lineform.location1">
                  <v-text-field v-model="lineform.location1.name" :rules="[vrules.required]" dense outlined>
                    <template v-slot:label>
                      去程起点(装货地址)<span class="red--text">*</span>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="6" v-if="lineform.location2">
                  <v-text-field v-model="lineform.location2.name" :rules="[vrules.required]" dense outlined>
                    <template v-slot:label>
                      去程终点(卸货地址)<span class="red--text">*</span>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="6" v-if="lineform.location3">
                  <v-text-field v-model="lineform.location3.name" :rules="[vrules.required]" dense outlined>
                    <template v-slot:label>
                      返程起点(装货地址)<span class="red--text">*</span>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="6" v-if="lineform.location4">
                  <v-text-field v-model="lineform.location4.name" :rules="[vrules.required]" dense outlined>
                    <template v-slot:label>
                      返程终点(卸货地址)<span class="red--text">*</span>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="4">
                  <v-text-field v-model="lineform.km" type="number" :rules="[vrules.required]" suffix="公里" dense
                    outlined>
                    <template v-slot:label>
                      运输里程<span class="red--text">*</span>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="4">
                  <v-text-field v-model="lineform.vkm" type="number" :rules="[vrules.required]" suffix="公里" dense
                    outlined>
                    <template v-slot:label>
                      续航里程<span class="red--text">*</span>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="4">
                  <v-text-field v-model="lineform.speed" type="number" :rules="[vrules.required]" suffix="公里/小时" dense
                    outlined>
                    <template v-slot:label>
                      时速<span class="red--text">*</span>
                    </template>
                  </v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-checkbox v-if="username === 'root'" v-model="lineform.editable">
              <template v-slot:label>
                <span v-if="lineform.editable" class="success--text">允许编辑节点</span>
                <span v-else class="error--text">禁止编辑节点</span>
              </template>
            </v-checkbox>
            <v-spacer></v-spacer>
            <v-btn color="primary" tile :disabled="!linevalid" @click="saveline">确定</v-btn>
            <v-btn tile @click="cancelsaveline">关闭</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <!--添加车头-->
    <v-dialog v-model="vehiclemodel" persistent :width="400">
      <v-form ref="vehicleform" v-model="vehiclevalid" lazy-validation>
        <v-card>
          <v-card-title class="grey lighten-4 pa-2 text-subtitle-1 mb-4 d-flex justify-space-between">
            <span class="text-h6">添加车头 <span class="error--text">{{ line ? line.text : '' }}</span></span>
            <v-icon @click="canceladdvehicle">mdi-close</v-icon>
          </v-card-title>
          <v-card-text>
            <v-container style="max-height:600px;overflow-y:auto;">
              <v-row>
                <v-col cols="12">
                  <v-autocomplete v-model="vehicleform.vehicleid" :items="linevehicles" :rules="[vrules.required]"
                    :menu-props="{ bottom: true, offsetY: true }" no-data-text="无" dense outlined>
                    <template v-slot:label>
                      车头<span class="red--text">*</span>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="12">
                  <v-menu ref="menu0" v-model="menu0" :close-on-content-click="false" :nudge-right="40"
                    :return-value.sync="vehicleform.stime" transition="scale-transition" offset-y max-width="290px"
                    min-width="290px">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="vehicleform.stime" :rules="[vrules.required]"
                        append-icon="mdi-clock-time-four-outline" dense outlined readonly v-bind="attrs" v-on="on">
                        <template v-slot:label>
                          起始时间<span class="red--text">*</span>
                        </template>
                      </v-text-field>
                    </template>
                    <v-time-picker v-if="menu0" v-model="vehicleform.stime" format="24hr" no-title scrollable full-width
                      @click:minute="$refs.menu0.save(vehicleform.stime)"></v-time-picker>
                  </v-menu>
                </v-col>
                <!-- <v-col cols="12">
                  <v-menu ref="menu1" v-model="menu1" :close-on-content-click="false" :nudge-right="40"
                    :return-value.sync="vehicleform.etime" transition="scale-transition" offset-y max-width="290px"
                    min-width="290px">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="vehicleform.etime" append-icon="mdi-clock-time-four-outline" dense outlined
                        readonly v-bind="attrs" v-on="on" clearable>
                        <template v-slot:label>
                          结束时间
                        </template>
                      </v-text-field>
                    </template>
                    <v-time-picker v-if="menu1" v-model="vehicleform.etime" format="24hr" no-title scrollable full-width
                      @click:minute="$refs.menu1.save(vehicleform.etime)"></v-time-picker>
                  </v-menu>
                </v-col> -->
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" tile :disabled="!vehiclevalid" @click="addvehicle">确定</v-btn>
            <v-btn tile @click="canceladdvehicle">关闭</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <!--编辑节点-->
    <v-dialog v-model="schedulemodel" persistent :width="400">
      <v-form ref="scheduleform" v-model="schedulevalid" lazy-validation>
        <v-card>
          <v-card-title class="grey lighten-4 pa-2 text-subtitle-1 mb-4 d-flex justify-space-between">
            <span class="text-h6">编辑节点</span>
            <v-icon @click="cancelsaveschedule">mdi-close</v-icon>
          </v-card-title>
          <v-card-text>
            <v-container style="max-height:600px;overflow-y:auto;">
              <v-row>
                <v-col cols="12">
                  <v-text-field v-model="scheduleform.minutes" :rules="[vrules.required]" type="number" suffix="分钟"
                    dense outlined>
                    <template v-slot:label>
                      作业用时<span class="red--text">*</span>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-checkbox v-model="scheduleform.driver_sync" dense outlined>
                    <template v-slot:label>
                      司机工时同步<span class="red--text">*</span>
                    </template>
                  </v-checkbox>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" tile :disabled="!schedulevalid" @click="saveschedule">确定</v-btn>
            <v-btn tile @click="cancelsaveschedule">关闭</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </v-container>
</template>
<script>
import _ from "underscore";
import { message } from "ant-design-vue";
import { mapState } from "vuex";
import VSnakeTimeline from "@/components/v-snake-timeline.vue";

export default {
  name: "Timecal",
  data() {
    return {
      headers: [
        { value: "index", width: 100, align: "center", text: "序号" },
        { value: "A", width: 120, align: "center", text: "时段" },
        { value: "B", width: 120, align: "center", text: "当前状态" },
        { value: "C", width: 150, align: "center", text: "当前地点" },
        { value: "D", width: 120, align: "center", text: "当前司机" },
        { value: "E", width: 120, align: "center", text: "当前车头" },
        { value: "F", width: 120, align: "center", text: "当前挂箱" },
        { value: "G", width: 120, align: "center", text: "作业内容" },
        { value: "H", width: 120, align: "center", text: "作业用时" },
        { value: "I", width: 120, align: "center", text: "行驶里程" },
        // { value: "J", width: 120, align: "center", text: "总用时" },
      ],
      rlist: [],
      list: [],
      S: 0,
      sections: [],
      section: null,
      A: 0,
      lines: [],
      line: null,
      lineid: "",
      linevehicles: [],
      B: 0,
      vehicles: [],
      vehicle: null,
      vehicleid: "",
      vrules: {
        required: (value) => !!value || "不能为空"
      },
      height: 600,
      showview: 'table',
      ignore_oneday: false,
      menu0: false,
      menu1: false,
      vehicleform: {},
      vehiclemodel: false,
      vehiclevalid: true,
      scheduleform: {},
      schedulemodel: false,
      schedulevalid: true,
      lineform: {},
      linemodel: false,
      linevalid: true,
      location1: {},
      location2: {},
      location3: {},
      location4: {},
      width: 200,
    };
  },
  computed: {
    ...mapState(["role", "username"]),
    list2() {
      let result = [];
      let items = [];
      let n = 0;
      for (let i = 0; i < this.rlist.length; i++) {
        items.push(this.rlist[i]);
        if (items.length === 8 || i === this.rlist.length - 1) {
          n++;
          if (n % 2 === 0) {
            result.push(...items.reverse());
          }
          else {
            result.push(...items);
          }
          items = [];
        }
      }
      return result;
    },
  },
  components: {
    VSnakeTimeline
  },
  watch: {

  },
  mounted() {
    this.height = window.innerHeight - 260;
    window.onresize = (e) => {
      console.log("onresize", window.innerHeight);
      this.height = window.innerHeight - 260;
      const divElement = document.getElementById('timeline-card');
      const divWidth = divElement.clientWidth;
      console.log("divWidth", divWidth);
      let width = Math.floor((divWidth - 400) / 6);
      if (width > 200) width = 200;
      this.width = width;
    };
    this.getdata();
    const divElement = document.getElementById('timeline-card');
    const divWidth = divElement.clientWidth;
    console.log("divWidth", divWidth);
    let width = Math.floor((divWidth - 400) / 6);
    if (width > 200) width = 200;
    this.width = width;
  },
  methods: {
    changeTabS(v) {
      console.log('changeTabS', v);
      this.S = v;
      this.A = 0;
      this.B = 0;
      this.getdata();
    },
    onEditA(targetKey, action) {
      console.log('onEditA', targetKey, action);
      if (action === "add") {
        this.showaddline();
      }
      else if (action === "remove") {
        let line = this.lines[targetKey];
        this.$confirm1("提示", `删除线路${line.text}`, () => {
          this.removeline(line.value);
        });
      }
    },
    changeTabA(v) {
      console.log('changeTabA', v);
      this.A = v;
      this.B = 0;
      this.getdata();
    },
    onEditB(targetKey, action) {
      console.log('onEditB', targetKey, action);
      if (action === 'add') {
        this.showaddvehicle();
      }
      else if (action === 'remove') {
        let line = this.lines.find(n => n.value === this.lineid);
        let vehicle = this.vehicles[targetKey];
        this.$confirm1("提示", `删除线路${line.text},${vehicle.text}`, () => {
          this.removevehicle(vehicle.value);
        });
      }
    },
    changeTabB(v) {
      console.log('changeTabB', v);
      this.B = v;
      this.getdata();
    },
    getdata(showlatestline = false, showlatestvehicle = false) {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/schedule2/line/list", { S: this.S, A: this.A, B: this.B, showlatestline, showlatestvehicle }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.rlist = res.data.list;
          this.list = this.makedata(res.data.list);
          this.sections = res.data.sections;
          this.S = res.data.S;
          this.section = res.data.sections[this.S].value;
          this.lines = res.data.lines;
          if (showlatestline) this.A = res.data.A;
          this.line = res.data.lines[this.A];
          this.lineid = res.data.lines[this.A]?.value || "";
          this.linevehicles = res.data.linevehicles;
          this.vehicles = res.data.vehicles;
          if (showlatestvehicle) this.B = res.data.B;
          this.vehicle = res.data.vehicles[this.B];
          this.vehicleid = res.data.vehicles[this.B]?.value || "";
          this.location1 = res.data.location1;
          this.location2 = res.data.location2;
          this.location3 = res.data.location3;
          this.location4 = res.data.location4;
        } else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    makedata(list) {
      let drivers = [];
      let vehicles = [];
      let gvehicles = [];
      list.forEach(n => {
        if (n.driver && !drivers.includes(n.driver.value)) {
          drivers.push(n.driver.value);
        }
        if (n.vehicle && !vehicles.includes(n.vehicle.value)) {
          vehicles.push(n.vehicle.value);
        }
        if (n.gvehicle && !gvehicles.includes(n.gvehicle.value)) {
          gvehicles.push(n.gvehicle.value);
        }
      });
      let result = [
        {
          D: drivers.length,
          E: vehicles.length,
          F: gvehicles.length,
        },
        ...list,
      ];
      if (result.length === 1) return [];
      return result;
    },
    showaddline() {
      this.lineform = {
        _id: "",
        section: "",
        departure: "",
        destination: "",
        km: "",
        vkm: "",
        speed: 75,
        location1: { name: "" },
        location2: { name: "" },
        location3: { name: "" },
        location4: { name: "" },
        editable: true,
      };
      this.linemodel = true;
    },
    showeditline() {
      this.lineform = {
        _id: this.lineid,
        section: this.line.section,
        departure: this.line.departure,
        destination: this.line.destination,
        km: this.line.km,
        vkm: this.line.vkm,
        speed: this.line.speed,
        location1: this.line.location1,
        location2: this.line.location2,
        location3: this.line.location3,
        location4: this.line.location4,
        editable: this.line.editable,
      };
      this.linemodel = true;
    },
    saveline() {
      if (!this.$refs.lineform.validate()) return;
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/schedule2/line/save", {
        lineid: this.lineid,
        form: this.lineform
      }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.linemodel = false;
          this.getdata(this.lineform._id === "", false);
        } else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    cancelsaveline() {
      this.$refs.lineform.resetValidation();
      this.linemodel = false;
    },
    removeline(lineid) {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/schedule2/line/remove", {
        lineid,
      }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.A = 0;
          this.B = 0;
          this.getdata();
        } else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    showaddvehicle() {
      this.vehicleform = {
        vehicleid: "",
        stime: "",
        etime: "",
      };
      this.vehiclemodel = true;
    },
    addvehicle() {
      if (!this.$refs.vehicleform.validate()) return;
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/schedule2/line/addvehicle", {
        lineid: this.lineid,
        form: this.vehicleform
      }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.vehiclemodel = false;
          this.getdata(false, true);
        } else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    canceladdvehicle() {
      this.$refs.vehicleform.resetValidation();
      this.vehiclemodel = false;
    },
    removevehicle(vehicleid) {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/schedule2/line/removevehicle", {
        lineid: this.lineid,
        vehicleid
      }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.B = 0;
          this.getdata();
        } else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    showeditschedule(item) {
      this.scheduleform = {
        _id: item._id,
        minutes: item.location.minutes,
        driver_sync: true,
      };
      this.schedulemodel = true;
    },
    saveschedule() {
      if (!this.$refs.scheduleform.validate()) return;
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/schedule2/lineschedule/save", {
        lineid: this.lineid,
        vehicleid: this.vehicleid,
        form: this.scheduleform
      }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.schedulemodel = false;
          this.getdata();
        } else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    cancelsaveschedule() {
      this.$refs.scheduleform.resetValidation();
      this.schedulemodel = false;
    },
    init() {
      this.$toast.loading({ message: "" });
      return this.$api.doAPI("/schedule2/lineschedule/init", {
        lineid: this.lineid,
        vehicleid: this.vehicleid,
        ignore_oneday: this.ignore_oneday
      }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.getdata();
        } else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    reset() {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/schedule2/lineschedule/reset", {
        lineid: this.lineid,
        vehicleid: this.vehicleid
      }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.getdata();
        } else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
  },
};
</script>
<style lang="less" scoped>
/deep/ .row {
  margin-bottom: 0 !important;
}

/deep/ .row+.row {
  margin-top: 0;
}

/deep/ .col,
.col-6 {
  padding-bottom: 0 !important;
}

¸ /deep/ .v-input--selection-controls {
  margin-top: 0;
  padding-top: 0;
}

/deep/ .v-data-table>.v-data-table__wrapper>table>tbody>tr>td {
  padding: 0 4px;
}

/deep/.ant-tabs-bar {
  margin: 0 0 8px 0;
}

p {
  margin: 0;
}
</style>